import { hasAnyRole, normalizeRole } from './rbac';

export const MASTER_ENTITY_CONFIG = {
  departments: {
    key: 'departments',
    singularLabel: 'Department',
    pluralLabel: 'Departments',
    routeBase: '/admin/master/departments',
  },
  subdepartments: {
    key: 'subdepartments',
    singularLabel: 'Sub-Department',
    pluralLabel: 'Sub-Departments',
    routeBase: '/admin/master/subdepartments',
  },
  designations: {
    key: 'designations',
    singularLabel: 'Designation',
    pluralLabel: 'Designations',
    routeBase: '/admin/master/designations',
  },
};

const normalizePermissionSet = (user) => {
  const roleKey = normalizeRole(user?.role);
  const fromUser = Array.isArray(user?.permissions) ? user.permissions : [];
  const fromRole = Array.isArray(user?.rolePermissions) ? user.rolePermissions : [];
  const fromRoleMap = Array.isArray(user?.rolePermissionsMap?.[roleKey]) ? user.rolePermissionsMap[roleKey] : [];
  return new Set([...fromUser, ...fromRole, ...fromRoleMap].map((item) => String(item || '').toLowerCase()).filter(Boolean));
};

export const getMasterCrudAccess = (user) => {
  const role = normalizeRole(user?.role);
  const permissions = normalizePermissionSet(user);
  const isAdminRole = hasAnyRole(role, ['workspace_admin', 'admin', 'superadmin']);
  const isHrAdminRole = hasAnyRole(role, ['hr_admin']);
  const canView = isAdminRole || isHrAdminRole || permissions.has('read');
  const canCreate = isAdminRole || isHrAdminRole || permissions.has('create');
  const canEdit = isAdminRole || isHrAdminRole || permissions.has('update');
  const canDelete = isAdminRole || permissions.has('delete');
  return { canView, canCreate, canEdit, canDelete };
};

export const flattenMasterHierarchy = (rows = []) => {
  const departments = rows.map((row) => ({
    id: row.id,
    name: row.name,
    location: row.location || null,
    is_active: Boolean(row.is_active),
  }));

  const subDepartments = rows.flatMap((department) =>
    (department.sub_departments || []).map((subDepartment) => ({
      id: subDepartment.id,
      name: subDepartment.name,
      is_active: Boolean(subDepartment.is_active),
      department_id: department.id,
      department_name: department.name,
    }))
  );

  const designations = rows.flatMap((department) => {
    const departmentLevel = (department.designations || []).map((designation) => ({
      id: designation.id,
      name: designation.name,
      is_active: Boolean(designation.is_active),
      department_id: department.id,
      department_name: department.name,
      sub_department_id: null,
      sub_department_name: null,
    }));
    const nested = (department.sub_departments || []).flatMap((subDepartment) =>
      (subDepartment.designations || []).map((designation) => ({
        id: designation.id,
        name: designation.name,
        is_active: Boolean(designation.is_active),
        department_id: department.id,
        department_name: department.name,
        sub_department_id: subDepartment.id,
        sub_department_name: subDepartment.name,
      }))
    );
    return [...departmentLevel, ...nested];
  });

  return { departments, subDepartments, designations };
};
